/**
 * Shared types for shift plan domain
 */
import { ErrorCode, PlanStatus } from "../utils/constants";

/**
 * Shift types
 */
export const ShiftTypes = {
  DAY_SHIFT: "DAY",
  NIGHT_SHIFT: "NIGHT",
} as const;

export type ShiftType = (typeof ShiftTypes)[keyof typeof ShiftTypes];

/**
 * Plan version identifiers
 */
export enum PlanVersion {
  STATIC_V1 = "STATIC_V1",
  RELO_STATION_ASSIGNMENT_V1 = "RELO_STATION_ASSIGNMENT_V1",
  LABOR_ALLOCATION_V3 = "LABOR_ALLOCATION_V3",
}

/**
 * Plan types
 */
export const PlanTypes = {
  PRE_SHIFT: "PRE_SHIFT",
  NEXT_DAY: "NEXT_DAY",
  INTRA_DAY: "INTRA_DAY",
} as const;

export type PlanType = (typeof PlanTypes)[keyof typeof PlanTypes];

export interface ErrorDetails {
  errorCode?: ErrorCode;
  errorMessage: string;
}

export interface CreateShiftPlanRequest {
  ofdDate: string;
  planType: PlanType;
  nodeId: string;
  warehouseId: string;
  planVersion: PlanVersion;
  clockWindowName: ShiftType;
  createdBy: string;
  takeOverPlan: boolean;
}

export interface CreateShiftPlanResponse {
  planId?: string;
  status?: PlanStatus;
  errorDetails?: ErrorDetails;
}

export interface GetAllShiftPlansRequest {
  nodeId: string;
  warehouseId: string;
  date: string;
  shiftType: ShiftType;
  queryDevPlanVersions?: boolean;
  planType?: PlanType;
  planVersion?: PlanVersion;
}

export interface SPMSGetShiftPlanResponse {
  [key: string]: string | boolean | number | undefined;
}

export interface GetAllShiftPlansResponse {
  shiftPlans: SPMSGetShiftPlanResponse[];
}
